// src/hooks/useAuth.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('gc_token'));
  const [username, setUsername] = useState(localStorage.getItem('gc_user'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (token) {
      fetch('/api/auth/verify', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(res => {
          if (res.ok) {
            setIsAuthenticated(true);
          } else {
            logout();
          }
        })
        .catch(() => logout());
    }
  // eslint-disable-next-line
  }, []);

  async function login(user, pass) {
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: user, password: pass })
      });

      const data = await res.json();

      if (res.ok && data.token) {
        const cleanToken = data.token.trim();
        localStorage.setItem('gc_token', cleanToken);
        localStorage.setItem('gc_user', data.username);
        setToken(cleanToken);
        setUsername(data.username);
        setIsAuthenticated(true);
        return { success: true, message: data.message };
      }

      return { success: false, message: data.error || 'Login failed' };
    } catch (err) {
      return { success: false, message: 'Connection failed' };
    }
  }

  function logout() {
    localStorage.removeItem('gc_token');
    localStorage.removeItem('gc_user');
    setToken(null);
    setUsername(null);
    setIsAuthenticated(false);
  }

  // Always reads the freshest token from localStorage
  const authFetch = useCallback((url, options = {}) => {
    const currentToken = localStorage.getItem('gc_token');
    return fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
        'Authorization': `Bearer ${currentToken}`,
      }
    });
  }, []);

  return (
    <AuthContext.Provider value={{
      isAuthenticated, username, token,
      login, logout, authFetch
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}